import React, { useState, useRef } from 'react';
import { Box, Button, Dialog, DialogTitle } from '@mui/material';
import './Spinner.css';

const NUMBERS = Array.from({ length: 12 }, (_, i) => ({
  label: (i + 1).toString(),
  color: `hsl(${(i + 1) * 30}, 70%, 60%)`, // different color for each
}));

export default function NumberSpinner() {
  const [rotation, setRotation] = useState(0);
  const [selectedLabel, setSelectedLabel] = useState('');
  const [showResult, setShowResult] = useState(false);
  const wheelRef = useRef(null);

  const startRotation = () => {
    if (!wheelRef.current) return;

    wheelRef.current.style.transition = 'none';
    wheelRef.current.style.transform = `rotate(${rotation % 360}deg)`;
    void wheelRef.current.offsetHeight;

    const spinDegrees = 360 * 5 + Math.floor(Math.random() * 360);
    setRotation(spinDegrees);

    wheelRef.current.style.transition = 'transform 4s cubic-bezier(0.25, 1, 0.5, 1)';
    wheelRef.current.style.transform = `rotate(${spinDegrees}deg)`;

    setTimeout(() => {
      const normalizedDegrees = spinDegrees % 360;
      const segmentAngle = 360 / NUMBERS.length;
      const index = Math.floor(((360 - normalizedDegrees) % 360) / segmentAngle);

      setSelectedLabel(NUMBERS[index].label);
      setShowResult(true);
    }, 4000);
  };

  return (
    <Box className="spinner-container">
      {/* Wheel Container with Triangle and Wheel */}
      <Box className="wheel-container">
        {/* Triangle Pointer */}
        <Box className="triangle-down" />

        {/* Spinner Wheel */}
        <Box
          component="ul"
          ref={wheelRef}
          className="circle"
          sx={{ transition: 'transform 0s' }}
        >
          {NUMBERS.map((item, index) => (
            <li
              key={index}
              className="wheel-part"
              style={{
                transform: `rotate(${index * 30}deg) skewY(-60deg)`,
              }}
            >
              <Box
                className="text"
                sx={{
                  backgroundColor: item.color,
                  color: 'black',
                }}
              >
                {item.label}
              </Box>
            </li>
          ))}
        </Box>
      </Box>

      {/* Spin Button */}
      <Button
        variant="contained"
        size="large"
        onClick={startRotation}
        sx={{
          background: 'linear-gradient(to right, #4facfe, #00f2fe)',
          borderRadius: '50px',
          px: 6,
          py: 1.5,
          fontWeight: 'bold',
          boxShadow: 3,
          '&:hover': {
            background: 'linear-gradient(to right, #00f2fe, #4facfe)',
          },
        }}
      >
        SPIN
      </Button>

      {/* Result Dialog */}
      <Dialog open={showResult} onClose={() => setShowResult(false)}>
        <DialogTitle sx={{ fontSize: '22px', fontWeight: 'bold', textAlign: 'center' }}>
          🎉 You got: {selectedLabel}
        </DialogTitle>
      </Dialog>
    </Box>
  );
}
